import style from './style.module.scss';
import Link from 'components/Link';
import classNames from 'classnames';
import {TLinkItem} from 'modules/footer/components/Footer/types';

interface IContactLinkListProps {
    className?: string;
    linkList: TLinkItem[];
}

export function ContactLinkList({linkList, className}: IContactLinkListProps) {
    return (
        <div className={classNames(style.contactLinkList, className)}>
            {linkList.map(({path, icon}, index) => (
                <Link href={path} key={index} target={'_blank'}>
                    <div className={style.icon}>{icon}</div>
                </Link>
            ))}
        </div>
    );
}
